export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Follower-White-b235a86a52a26cda4bed7adbb9f4aa3b.svg";